'use strict';

angular.module('far.modals.slider', [])
.controller('SliderController', function($uibModalInstance, slides, selectedSlide) {
	var vm = {
		slides: slides.map(function(slide) {
			slide.active = slide.id == selectedSlide.id;
			slide.style = {
				'background-image': 'url(' + slide.image_path + ')'
			};

			return slide;
		}),
		close: function() {
			$uibModalInstance.close();
		}
	};

	return vm;
});